import { useEffect, useState } from "react";
import useConfig from "~/shared/api/useConfig";
import mbc from "~/shared/functions/mbc";

const useDarkMode = () => {
	const config = useConfig();

	const [isDarkModeOn, setIsDarkModeOn] = useState(() => {
		const prefersDarkmodeMedia = window.matchMedia("(prefers-color-scheme: dark)").matches;
		if (config.isProduction) {
			return mbc.isNative() ? prefersDarkmodeMedia : false;
		}

		const prefersDarkmodeLocalStorage = localStorage.getItem("ppm-portal-darkmode-preference");

		return prefersDarkmodeLocalStorage ? prefersDarkmodeLocalStorage === "true" : prefersDarkmodeMedia;
	});

	useEffect(() => {
		const checkIfDarkMode = () => {
			setIsDarkModeOn(localStorage.getItem("ppm-portal-darkmode-preference") === "true");
		};

		window.addEventListener("darkmode", checkIfDarkMode);

		return () => {
			window.removeEventListener("darkmode", checkIfDarkMode);
		};
	}, []);

	return [isDarkModeOn];
};

export default useDarkMode;
